import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPhoneVolume,
  faChevronRight,
  faVideoCamera,
} from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

const NextAppointmentCard = ({ appointment, onClick }) => {
  function formatDate(datetimeStr, type = 'date') {
    const m = moment(datetimeStr)
    if (type === 'date') {
      // moment's "Do" format token includes ordinal (e.g., 1st, 2nd, 3rd)
      return m.format('dddd Do MMMM YYYY')
    }

    if (type === 'time') {
      // 12-hour format with AM/PM, zero-padded hour and minute
      return m.format('h:mm A')
    }

    return '' // fallback if type is unknown
  }

  if (!appointment) {
    return null
  }

  return (
    <div
      className="bg-white border-l-8 border-l-[#969EF4] shadow-md rounded-xl flex items-center justify-between p-4 max-w-md cursor-pointer"
      onClick={onClick}
    >
      <div className="pl-2 space-y-2">
        <div>
          <div className='flex gap-2 items-center mb-2'>
            <FontAwesomeIcon
              icon={appointment.type === 'Phone' ? faPhoneVolume : faVideoCamera}
              className="text-[#979EF4] text-xl"
              />
            <h3 className="font-semibold text-lg">
              GP {appointment.type} Consultation
            </h3>
          </div>
          <div className='bg-gray-100 rounded-md px-2 py-1 inline-block mb-2 text-sm'>
            <p> For {appointment?.booking_for} </p>
          </div>
          <p className="text-sm text-gray-600">
            {formatDate(appointment.start_time_format, 'date')} |{' '}
            {formatDate(appointment.start_time_format, 'time')}
          </p>
        </div>
      </div>
      <div className="text-gray-400 text-xl">
        <FontAwesomeIcon
          icon={faChevronRight}
          className="text-[#979EF4] text-xl"
        />
      </div>
    </div>
  )
}

export default NextAppointmentCard
